import { useState, useCallback } from 'react';

/**
 * useToast Hook
 * Manages toast notifications state
 * Used internally by ToastProvider
 */
export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, options = {}) => {
    const id = Date.now().toString();
    const toast = {
      id,
      message,
      variant: options.variant || 'info',
      title: options.title,
      duration: options.duration || 5000,
    };

    setToasts((prev) => [...prev, toast]);

    return id;
  }, []);

  const removeToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  const success = useCallback(
    (message, options) => showToast(message, { ...options, variant: 'success' }),
    [showToast]
  );

  const error = useCallback(
    (message, options) => showToast(message, { ...options, variant: 'error' }),
    [showToast]
  );

  const warning = useCallback(
    (message, options) => showToast(message, { ...options, variant: 'warning' }),
    [showToast]
  );

  const info = useCallback(
    (message, options) => showToast(message, { ...options, variant: 'info' }),
    [showToast]
  );

  return {
    toasts,
    showToast,
    removeToast,
    success,
    error,
    warning,
    info,
  };
};

export default useToast;
